import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { LoadingController, ToastController } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { ChatService } from 'src/app/services/chat.service';
import { ValidarToken } from 'src/app/validators/valida-datos';

@Component({
  selector: 'app-view-plantillas',
  templateUrl: './view-plantillas.component.html',
  styleUrls: ['./view-plantillas.component.scss'],
})
export class ViewPlantillasComponent implements OnInit {

  classUser: any;
  plantillas: any;
  vista: number;
  plant: any;
  nombreArchivoUpload: string;
  archivo: any;
  urlAdmin: string;
  statusBtn: number;
  nombreFile: string;
  previsualizacion: any;
  plantillaActual: any;

  constructor(
    private storage: Storage,
    private chatSevice: ChatService,
    private loadingController: LoadingController,
    private toastController: ToastController,
    private sanitizer: DomSanitizer
  ) {
    this.vista = 0;
    this.plantillas = [];
    this.plant = {};
    this.statusBtn = 0;
    this.previsualizacion = null;
    this.plantillaActual = 0;
  }

  ngOnInit() {
    this.presentLoading('Cargando Plantillas...');
    this.classUser = new ValidarToken(this.storage);
    setTimeout(() => {
      this.consultaPlantillas();
      this.getUrlAdmin();
      // console.log(this.urlAdmin);
    }, 500);
  }

  back() {
    this.vista = 0;
  }

  getUrlAdmin() {
    this.chatSevice.getUrlAdmin(this.classUser.idAdmin, this.classUser.id,
      this.classUser.rol, this.classUser.token, '').subscribe(
        (res: any) => {
          const { url } = res;
          this.urlAdmin = url;
          // console.log(plantillas);
        },
        err => {
          this.loadingController.dismiss();
          console.log(err);
        }
      );
  }

  // getImgPlantilla() {
  //   this.chatSevice.getImgPlan(this.plant.nombre_imagen, this.urlAdmin).subscribe(
  //       (res: any) => {
  //         const { url } = res;
  //         this.urlAdmin = url;
  //         // console.log(plantillas);
  //       },
  //       err => {
  //         this.loadingController.dismiss();
  //         console.log(err);
  //       }
  //     );
  // }

  consultaPlantillas() {
    this.chatSevice.consultaPlantillas(this.classUser.idAdmin, this.classUser.id,
      this.classUser.rol, this.classUser.token, 1, 1, '').subscribe(
        (res: any) => {
          this.loadingController.dismiss();
          const { plantillas } = res;
          this.plantillas = plantillas;
          // console.log(plantillas);
        },
        err => {
          this.loadingController.dismiss();
          console.log(err);
        }
      );
  }

  async presentLoading(message) {
    const loading = await this.loadingController.create({
      cssClass: 'my-custom-class',
      message,
      // duration: 2000
    });
    await loading.present();
  }

  editImagen(plantilla) {
    this.plant = plantilla;
    this.vista = 1;
    if(this.plant.id != this.plantillaActual) {
      this.previsualizacion = null;
      this.plantillaActual = this.plant.id;
    }
    // console.log(plantilla);
  }


  // ----- Metodo para cargar imagenes de las plantillas -----
  async file(ev) {
    const archivoCap = ev.target.files[0];
    this.nombreArchivoUpload = archivoCap.name;
    const nombreCortado = archivoCap.name.split('.');
    const extension = nombreCortado[ nombreCortado.length -1 ];
    const extensionesValidas = ['png', 'PNG', 'jpg', 'JPG', 'JPEG', 'jpeg'];
      if(!extensionesValidas.includes(extension)){
        this.presentToast('Error, Extensión inválida', 'danger');
        return;
      }
      if(archivoCap.size <= 5000000) {
        this.archivo = archivoCap;
        this.extraerBase64(archivoCap).then((imagen: any) => {
          this.previsualizacion = imagen.base;
     });
        this.statusBtn = 1;
      } else  {
        this.presentToast('El tamaño de la imagen debe se ser menor a 5 MG', 'warning');
      }
  }

  uploadArchivo() {
    this.presentLoading('Actualizando imagen');
    const formFile = new FormData();
    formFile.append('img', this.archivo);
    this.chatSevice.uploadImgPlan(this.plant.nombre_whatsapp, this.classUser.idAdmin, this.urlAdmin, formFile).subscribe(
      (res: any) => {
        if ( res.status === 'success') {
          // this.presentToast('Imagen cargada!', 'success');
          this.nombreFile = res.nombreImg;
          this.actualizarPlantilla()
        } else {
          this.previsualizacion = null;
        }
      },
      error => {
        console.log(error);
        this.previsualizacion = null;
        this.loadingController.dismiss();
        this.presentToast('Hubo un error al cargar el archivo. Intenta más tarde', 'danger');
      });
  }

  actualizarPlantilla() {
    const data = {
      idAdmin: this.classUser.idAdmin,
      nombre_imagen: this.nombreFile
    };
    this.urlAdmin = '';

    this.chatSevice.updatePlantilla(data, this.plant.id, this.classUser.id,
      this.classUser.rol, this.classUser.token, '').subscribe(
        (res: any) => {
          // console.log(res)
          this.loadingController.dismiss();
          if(res.status == 'success') {
            this.getUrlAdmin();
          this.presentToast('Imagen actualizada correctamente', 'success');
          // console.log(plantillas);
          } else {
            this.previsualizacion = null;
          }
        },
        err => {
          this.loadingController.dismiss();
          this.previsualizacion = null;
          console.log(err);
        }
      );
  }

  async presentToast(message, color) {
    const toast = await this.toastController.create({
      message,
      duration: 1500,
      position: 'bottom',
      color
    });
  
    await toast.present();
  }

  extraerBase64 = async ($event: any) => new Promise((resolve, reject) => {
    try {
      const unsafeImg = window.URL.createObjectURL($event);
      const image = this.sanitizer.bypassSecurityTrustUrl(unsafeImg);
      const reader = new FileReader();
      reader.readAsDataURL($event);
      reader.onload = () => {
        resolve({
          base: reader.result
        });
      };
      reader.onerror = error => {
        resolve({
          base: null
        });
      };
  
    } catch (e) {
      return null;
    }
  });

}
